var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaCondividiOut2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19.99957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1579,19.99957a.52649.52649,0,0,1-.4636-.27652l-4.4212-8.2102a.52687.52687,0,0,1,.09149-.62191l9.16-9.16L1.89778,6.93952,5.81425,8.89775a.52637.52637,0,1,1-.4708.9416L.2911,7.31266A.52643.52643,0,0,1,.36,6.34228L19.29576.03069a.52079.52079,0,0,1,.13055-.02878.67067.67067,0,0,1,.07916-.001h.001a.52528.52528,0,0,1,.3382.15214l.001.001.001.001.001.001.001.001h0a.5254.5254,0,0,1,.15008.33716h0v.001a.50934.50934,0,0,1-.001.07915v.001h0A.51516.51516,0,0,1,19.96907.704l-6.31159,18.9358a.52519.52519,0,0,1-.45435.35772C13.18771,19.99854,13.17332,19.99957,13.1579,19.99957ZM9.38534,11.35865l3.65846,6.79267L18.26885,2.47515Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaCondividiOut2);
export default __webpack_public_path__ + "static/media/IconaCondividiOut2.9259c665a3781f3e8ac5f94c4292b948.svg";
export { ForwardRef as ReactComponent };